import clsx from 'clsx';
import { FC } from 'react';
import { useClickAnchorContext } from '../../../ClickMenu/context';
import { Icon } from '../../../Icon';
import { useDropdownContext } from '../dropdown.context';
import { IDropdownOption } from '../types';

export interface DropdownOptionProps extends IDropdownOption {
  subtitle?: string;
  disabled?: boolean;
  leading?: JSX.Element;
  className?: HTMLButtonElement['className'];
}

export const DropdownOption: FC<DropdownOptionProps> = ({
  id,
  label,
  className,
  leading,
  value,
  disabled,
  subtitle,
}) => {
  const { selected, setSelected } = useDropdownContext();
  const { setOpen } = useClickAnchorContext();
  return (
    <button
      role="option"
      type="button"
      onClick={() => {
        setOpen(false);
        if (value) {
          setSelected({ id, label, value });
        } else {
          setSelected(null);
        }
      }}
      className={clsx(
        'group flex px-4 py-3',
        id !== 'Dropdown_clear_selection' &&
          'focus:bg-palette-600 hover:bg-palette-600 focus:dark:bg-palette-600 hover:dark:bg-palette-600',
        disabled && 'opacity-40',
        className
      )}
      disabled={disabled}
    >
      {leading && <div className="mr-3 text-palette-600 group-hover:text-palette-100">{leading}</div>}
      <div className="flex flex-col items-start flex-1">
        <span
          className={clsx(
            id === 'Dropdown_clear_selection'
              ? 'dark:text-darkMode-gray-light/70 text-darkMode-gray-light group-hover:text-palette-600 group-focus:text-palette-600'
              : 'dark:text-palette-100 text-darkMode-gray-medium group-hover:text-palette-100 dark:group-hover:text-palette-1100 group-hover:font-medium',
            'text-left text-lg !leading-6 '
          )}
        >
          {label}
        </span>
        {subtitle && <p className={clsx('text-sm leading-[18px] dark:group-hover:text-palette-1100')}>{subtitle}</p>}
      </div>
      {selected?.id === id && (
        <Icon
          icon="check"
          className="ml-3 text-palette-600 group-hover:text-palette-100 dark:group-hover:text-palette-1100 group-hover:font-medium"
        />
      )}
    </button>
  );
};
